import React, { useRef } from 'react'
import { useRouter } from 'next/router'
import { getClient } from '../client'
import { groqAllListings } from '../lib/libFunctions'
import approvedListingLocations from '../lib/approved-listing-locations.cjs'

// Styles
import { base } from '../styles/base/_allBase.styles'
const { GridItem_HeaderSection, GridContainer_Page_Layout, Page_Main_Grid_Container } = base

// Components
import SEO from '../components/seo-head/seo-head'
import SectionOne from '../components/section-one/section-one.jsx'
import { Header } from '../components/header/header'
import { Footer } from '../components/footer/footer.component.jsx'
import { ListingGrid } from '../components/listing-grid/listing-grid.component'

const header = {
  header: 'Explore Selong Belanak',
  subheader:
    'Browse every place to eat, stay and surf around Selong Belanak — on the map and in the directory below.',
}
const seo = {
  titleFormat: 'complete',
  metaTitle: 'Selong Belanak Map | Places to Eat, Stay & Surf',
  metaDesc: 'Explore the Selong Belanak map and directory. Find restaurants, hotels, villas and surf schools by location, then open each listing for practical details.',
}

export default function Explore({ listings }) {
  const sectionOneRef = useRef()
  const router = useRouter()

  return (
    <GridContainer_Page_Layout>
      <SEO seo={seo} router={router} header={header} />
      <GridItem_HeaderSection>
        <header ref={sectionOneRef}>
          <Header />
        </header>
      </GridItem_HeaderSection>
      <main>
        <Page_Main_Grid_Container>
          <SectionOne header={header} variant="directory" />
          <ListingGrid listings={listings} filterByCategory showMap />
          <Footer />
        </Page_Main_Grid_Container>
      </main>
    </GridContainer_Page_Layout>
  )
}

export async function getServerSideProps() {
  const listings = await getClient().fetch(groqAllListings())
  return { props: { listings: (listings || []).map(approvedListingLocations.applyApprovedListingLocation) } }
}
